import SentimentBox from "./components/SentimentBox";

function App() {
  return <SentimentBox />;
}

export default App;
